// src/hooks/useRoles.js
// Live role list + antd-ready options for every role dropdown in the app.
import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchRoles } from '../services/rolesApi';

// Pass the currently-stored role so a legacy value that no longer matches any
// role is still shown (flagged) instead of the select rendering blank.
export const useRoles = (currentKey) => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      setRoles(await fetchRoles());
    } catch (err) {
      console.error('Failed to load roles', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  // Kept to { value, label } only — rc-select spreads any extra keys onto the
  // rendered node, so the full role object stays out of the option.
  const options = useMemo(() => {
    const opts = roles.map((r) => ({ value: r.key, label: r.name }));
    if (!loading && currentKey && !roles.some((r) => r.key === currentKey)) {
      opts.push({ value: currentKey, label: `${currentKey} — unknown role` });
    }
    return opts;
  }, [roles, currentKey, loading]);

  const byKey = useMemo(
    () => roles.reduce((acc, r) => { acc[r.key] = r; return acc; }, {}),
    [roles],
  );

  return { roles, options, byKey, loading, reload };
};

export default useRoles;
